import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FETCH_SUPPLIER_BY_ID, GET_SUPPLIER_CODE, GET_SUPPLIERS } from '../graphql/suppliers.query';
import { CREATE_SUPPLIER, REMOVE_SUPPLIER, UPDATE_SUPPLIER } from '../graphql/suppliers.mutation';

@Injectable({
  providedIn: 'root',
})
export class SupplierService {
  constructor(private apollo: Apollo) {}

  fetchSuppliers(search: string = ''): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_SUPPLIERS,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.suppliers || []));
  }

   fetchSingleSupplier(id: any): Observable<any> {
      return this.apollo
        .use('accounts')
        .query<any>({
          query: FETCH_SUPPLIER_BY_ID,
          variables: {
            id
          },
          fetchPolicy: 'network-only',
        })
        .pipe(map((result) => result.data?.supplier || []));
    }

  createSupplier(createSupplierInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: CREATE_SUPPLIER,
      variables: {
        createSupplierInput: createSupplierInput,
      },
    });
  }

  updateSupplier(supplierData: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: UPDATE_SUPPLIER,
      variables: {
        updateSupplierInput: supplierData,
      },
    });
  }

  deleteSupplier(id: number): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: REMOVE_SUPPLIER,
      variables: { id },
    });
  }

   fetchSupplierCode(): Observable<any> {
      return this.apollo
        .use('accounts')
        .watchQuery<any>({
          query: GET_SUPPLIER_CODE,
          fetchPolicy: 'network-only',
        })
        .valueChanges.pipe(map((result) => result?.data?.generateSupplierCode));
    }
}
